(() => {
    window.Dashboard = window.Dashboard || {};

    window.Dashboard.Models = window.Dashboard.Models || {};
    window.Dashboard.Models.Users = window.Dashboard.Models.Users || {};

    class Role {

        initialiseRole(role) {
            const self = Object.assign(this, role);
            if (!self.RoleId && role.Id) {
                self.RoleId = role.Id;
            }
            return self;
        }

        RoleId = undefined;
        BrandId = undefined;
        ProvinceId = undefined;
        StoreId = undefined;
        CallCenterId = undefined;
        GroupId = undefined;
        UserId = undefined;
        IsAdding = false;
        selectedBrands = [];
        selectedCallCenters = [];
        selectedStores = [];
        selectedGroups = [];
        selectedProvinces = [];
        selected = false;
        brandContextRequired = false;
        callCenterContextRequired = false;
        storeContextRequired = false;
        groupContextRequired = false;
        provinceContextRequired = false;
        invalidRoleContext = false;

        initialiseRoleContextMapping(roleContextMapping) {
            if (!roleContextMapping) {
                return;
            }
            this.brandContextRequired = roleContextMapping.Brand;
            this.callCenterContextRequired = roleContextMapping.CallCenter;
            this.storeContextRequired = roleContextMapping.Store;
            this.groupContextRequired = roleContextMapping.Group;
            this.provinceContextRequired = roleContextMapping.Province;
        }

        hasContext() {
            return !!this.BrandId
                || !!this.CallCenterId
                || !!this.StoreId
                || !!this.GroupId
                || !!this.ProvinceId;
        }

        setRoleAndContextSelection(userRole, brands, callCenters, stores, groups, provinces) {
            // Only select roles the logged in user has all the contexts for
            // example, if the role requires brand and store context, then make sure
            // the contexts the currently logged in user contains the user they're editing's brand and store
            if (userRole.BrandId && this.brandContextRequired) {
                if (!this.selected) {
                    this.selected = _.some(brands, function (brand) {
                        return brand.Id === userRole.BrandId;
                    });
                }
                if (this.selected) {
                    this.selectedBrands.push(userRole.BrandId);
                }
            }
            if (userRole.CallCenterId && this.callCenterContextRequired) {
                if (!this.selected) {
                    this.selected = _.some(callCenters, function (callCenter) {
                        return callCenter.Id === userRole.CallCenterId;
                    });
                }
                if (this.selected) {
                    this.selectedCallCenters.push(userRole.CallCenterId);
                }
            }
            if (userRole.StoreIds.length > 0 && this.storeContextRequired) {
                if (!this.selected) {
                    this.selected = _.some(stores, function (store) {
                        return userRole.StoreIds.indexOf(store.Id) > -1;
                    });
                }
                if (this.selected) {
                    this.selectedStores = this.selectedStores.concat(userRole.StoreIds);
                }
            }
            if (userRole.GroupId && this.groupContextRequired) {
                if (!this.selected) {
                    this.selected = _.some(groups, function (group) {
                        return group.Id === userRole.GroupId;
                    });
                }
                if (this.selected) {
                    this.selectedGroups.push(userRole.GroupId);
                }
            }
            if (userRole.ProvinceId && this.provinceContextRequired) {
                if (!this.selected) {
                    this.selected = _.some(provinces, function (province) {
                        return province.Id === userRole.ProvinceId;
                    });
                }
                if (this.selected) {
                    this.selectedProvinces.push(userRole.ProvinceId);
                }
            }

            // If this is a role without a context like Reportio user, then it is selected and no context requirements are checked
            if (!userRole.hasContext()) {
                this.selected = true;
            }
        }

        validateRole() {
            var result = {
                success: true,
                reason: ''
            };

            // Only check roles that have been selected
            if (!this.selected) {
                return result;
            }

            // Check the required contexts are set, excluding the current user context as that is added by default
            if (this.brandContextRequired && this.selectedBrands.length === 0 && !this.currentBrandContext) {
                result.success = false;
                result.reason = 'A brand context is required for this role, but none is selected';
            }
            if (this.callCenterContextRequired && this.selectedCallCenters.length === 0 && !this.currentCallCenterContext) {
                result.success = false;
                result.reason = 'A call center context is required for this role, but none is selected';
            }
            if (this.storeContextRequired && this.selectedStores.length === 0 && !this.currentStoreContext) {
                result.success = false;
                result.reason = 'A store context is required for this role, but none is selected';
            }
            if (this.groupContextRequired && this.selectedGroups.length === 0) {
                result.success = false;
                result.reason = 'A group context is required for this role, but none is selected';
            }
            if (this.provinceContextRequired && this.selectedProvinces.length === 0) {
                result.success = false;
                result.reason = 'A province context is required for this role, but none is selected';
            }

            return result;
        }

        setContextFromRole(role, storeToBrandLookup) {
            if (!role) {
                throw new Error(`Unable to set context from role: no role provided`);
            }
            if (this.groupContextRequired) {
                this.GroupId = role.GroupId;
            }
            if (this.callCenterContextRequired) {
                this.CallCenterId = role.CallCenterId;
            }
            if (this.storeContextRequired) {
                this.StoreId = role.StoreId;
            }
            this._setBrandIdFrom(
                role,
                storeToBrandLookup
            );
        }

        _setBrandIdFrom(role, storeToBrandLookup) {
            if (!this.brandContextRequired) {
                return;
            }
            if (role.BrandId) {
                this.BrandId = role.BrandId;
                return;
            }
            if (!role.StoreId) {
                throw new Error(`Brand context is required, but no brand id found and no store id to infer brand from`);
            }
            if (!storeToBrandLookup) {
                throw new Error(`Cannot infer brand id for store without injected storeToBrandLookup`);
            }
            this.BrandId = storeToBrandLookup[role.StoreId];
            if (!this.BrandId) {
                throw new Error(`Cannot infer brand from store id ${role.StoreId}: store not found in lookup`);
            }
        }

        setContextForRole(
            groups,
            brands,
            callCenters,
            stores
        ) {
            if (this.groupContextRequired) {
                const [ group ] = groups;
                this.GroupId = group.Id;
            }
            if (this.brandContextRequired) {
                const [ brand ] = brands;
                this.BrandId = brand.Id;
            }
            if (this.callCenterContextRequired) {
                const [ callCenter ] = callCenters;
                this.CallCenterId = callCenter.Id;
            }
            if (this.storeContextRequired) {
                const [ store ] = stores;
                this.StoreId = store.Id;
            }
        }

        setCurrentContextOnRole(userContext) {
            if (userContext.BrandId && this.brandContextRequired) {
                this.currentBrandContext = true;
            }

            if (userContext.CallCenterId && this.callCenterContextRequired) {
                this.currentCallCenterContext = true;
            }

            if (userContext.StoreId && this.storeContextRequired) {
                this.currentStoreContext = true;
            }
        };

        addSingleContextByDefault(brands, callCenters, stores, groups, provinces) {
            if (this.checkSingleContextAvailable(Dashboard.ContextTypes.BrandContext, brands)) {
                this.selectedBrands.push(brands[0].Id);
            }
            if (this.checkSingleContextAvailable(Dashboard.ContextTypes.CallCenterContext, callCenters)) {
                this.selectedCallCenters.push(callCenters[0].Id);
            }
            if (this.checkSingleContextAvailable(Dashboard.ContextTypes.StoreContext, stores)) {
                this.selectedStores.push(stores[0].Id);
            }
            if (this.checkSingleContextAvailable(Dashboard.ContextTypes.GroupContext, groups)) {
                this.selectedGroups.push(groups[0].Id);
            }
            if (this.checkSingleContextAvailable(Dashboard.ContextTypes.ProvinceContext, provinces)) {
                this.selectedProvinces.push(provinces[0].Id);
            }
        };

        checkSingleContextAvailable(contextType, contextCollection) {
            switch (contextType) {
                case Dashboard.ContextTypes.BrandContext:
                    return (this.brandContextRequired && this.selectedBrands.length === 0 && contextCollection.length === 1);
                case Dashboard.ContextTypes.CallCenterContext:
                    return (this.callCenterContextRequired && this.selectedCallCenters.length === 0 && contextCollection.length === 1);
                case Dashboard.ContextTypes.StoreContext:
                    return (this.storeContextRequired && this.selectedStores.length === 0 && contextCollection.length === 1);
                case Dashboard.ContextTypes.GroupContext:
                    return (this.groupContextRequired && this.selectedGroups.length === 0 && contextCollection.length === 1);
                case Dashboard.ContextTypes.ProvinceContext:
                    return (this.provinceContextRequired && this.selectedProvinces.length === 0 && contextCollection.length === 1);
            }
        }
    }

    window.Role = Role;
    window.Dashboard.Models.Users.Role = Role;
})();
